import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ref, watch } from "vue";
export default {
  __name: 'SettingRow',
  props: {
    grades: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dekitusId: {
      type: String,
      default: ""
    },
    currentStudent: {
      type: Object,
      default: function _default() {}
    },
    dekitusStudents: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ["handleStudentChange"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var selectedGradeId = ref(null);
    var selectedClassroomId = ref(null);
    var selectedStudentId = ref(props.currentStudent && props.currentStudent.id ? props.currentStudent.id : null);
    watch(function () {
      return selectedStudentId.value;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              emit("handleStudentChange", {
                dekitusId: props.dekitusId,
                studentId: selectedStudentId.value
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return {
      __sfc: true,
      props: props,
      selectedGradeId: selectedGradeId,
      selectedClassroomId: selectedClassroomId,
      selectedStudentId: selectedStudentId,
      emit: emit
    };
  }
};